import { MutationKey } from '@tanstack/react-query';

import { GenericFailure, UserId } from '@playq/services-shared';
import { AppID, Environment } from '@playq/octopus-common';
import { DeletedIdentity } from '@playq/services-fingerprint';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';

export type DestroyUserDataOnAllServicesType = {
  env: Environment;
  appId: AppID;
  userId: UserId;
};
export const destroyUserDataOnAllServicesMutationKey: MutationKey = [
  'playerlookup',
  'mutation',
  'destroyUserDataOnAllServices',
];

export const useDestroyUserDataOnAllServices = (
  options?: UseMutationOptionsExtended<DeletedIdentity, GenericFailure | Error, DestroyUserDataOnAllServicesType>
) =>
  useEitherMutation(
    ({ env, appId, userId }) => services2.playerLookupService.destroyUserDataOnAllServices(env, appId, userId),
    {
      mutationKey: destroyUserDataOnAllServicesMutationKey,
      ...options,
    }
  );
